<script lang="ts">
import type { HeaderBanner } from '@/components/banners/header/HeaderBannerBaseCard.vue'
import HeaderBannerCard from '@/components/banners/header/HeaderBannerCard.vue'
import AppCarousel from '@/components/carousel/AppCarousel.vue'
import CarouselItem from '@/components/carousel/CarouselItem.vue'
import { usePromotions } from '@/composables/usePromotions'
import { defineComponent, onMounted } from 'vue'

export default defineComponent({
  components: {
    AppCarousel,
    CarouselItem,
    HeaderBannerCard,
  },
  props: {
    title: {
      type: String,
    },
  },
  setup() {
    const { loadPromotions, showWelcomeBanner } = usePromotions()

    onMounted(() => {
      void loadPromotions()
    })

    return {
      showWelcomeBanner,
    }
  },
  data() {
    return {
      bannerJersey: {
        variant: 'clipped',
        text: 'WIN A BOX VS DERBY FOR 10 PEOPLE FOR FREE',
        cta_text: 'Enter Now',
        show_trustpilot: false,
        show_logo: false,
        route: {
          name: 'campaign',
          params: { campaignCode: 'win-a-hospitality-experience' },
        },
        image_url: '/assets/images/banners/saints.webp',
      } as HeaderBanner,
      bannerMysteryBox: {
        variant: 'clipped',
        text: 'OPEN YOUR SAINTS PACK',
        // subtext: '',
        cta_text: 'Win Now',
        show_trustpilot: false,
        show_logo: false,
        route: {
          name: 'instant-win',
          params: { instantWinCode: 'saints-ipswich-pack' },
          class: '!bg-pure-white !text-black',
        },
        image_url: '/assets/images/banners/saints-pack-1_1.png',
      } as HeaderBanner,
      bannerRangeRover: {
        variant: 'image',
        text: 'Win This Defender For Free!',
        cta_text: 'Enter Now',
        show_trustpilot: true,
        show_logo: false,
        route: {
          name: 'campaign',
          params: { campaignCode: 'win-land-rover-defender' },
        },
        image_url: '/assets/images/banners/defender-4_5.webp',
      } as HeaderBanner,
    }
  },
})
</script>

<template>
  <AppBanner
    aria-labelledby="banner-section-label"
    class="banner-section-banner !pt-0 @sm/main:!pt-10"
  >
    <span id="banner-section-label" class="sr-only">
      Check out our latest campaigns and instant prize games!
    </span>

    <AppCarousel
      :title
      :autoplay="false"
      :show-navigation="false"
      framed
      frame-class="@md/main:mx-0 my-0 !p-0 bg-transparent border-0"
      container-class="!gap-0 md:gap-3"
    >
      <CarouselItem class="w-full @sm/main:w-1/2 @lg/main:w-1/3">
        <HeaderBannerCard :banner="bannerJersey" />
      </CarouselItem>

      <CarouselItem class="w-full @sm/main:w-1/2 @lg/main:w-1/3">
        <HeaderBannerCard :banner="bannerMysteryBox" />
      </CarouselItem>

      <CarouselItem class="w-full @sm/main:w-1/2 @lg/main:w-1/3">
        <HeaderBannerCard :banner="bannerRangeRover" />
      </CarouselItem>
    </AppCarousel>
  </AppBanner>
</template>

<style lang="scss" scoped>
.banner-section-banner {
  @apply pb-0 px-0 @md/main:px-8;

  &:deep(.carousel-header) {
    @apply px-3 @md/main:px-0;
  }
}
</style>
